


















































































































































































































































































































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  reactive,
  ref,
  toRefs,
} from '@vue/composition-api';
import { BrowseIcon, DownloadIcon, EditIcon, SaveIcon, UserIcon, EllipsisIcon } from 'tdesign-icons-vue';
import { isArray } from 'lodash';
import Cookies from 'js-cookie';

// 引入组件
import Breadcrumb from '@/renderer/components/SpacePage/components/Breadcrumb.vue';
import MobileList from '@/renderer/views/share/components/MobileList.vue';
import SelectAnySpaceTargetFolder from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/index.vue';
import SaveDetail from '@/renderer/views/share/components/SaveDetail.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import UpgradeDialog from '@/renderer/components/dialog/UpgradeAccount/UpgradeDialog.vue';

// 引入 compositions
import FileIcon from '@/renderer/components/Base/BaseTableFileIcon/FileIcon.vue';
import listHandler from '@/renderer/components/SpacePage/compositions/listHandler';
import downloadHandler from '@/renderer/components/SpacePage/compositions/downloadHandler';
import openPreviewHandler from '@/renderer/components/SpacePage/compositions/openPreviewHandler';
import saveToNetDiscHandler from '@/renderer/views/share/compositions/saveToNetDiscHandler';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';

// 引入工具类
import shareAccessTokenManager from '@/renderer/scripts/utils/AccessTokenManager/share';
import { can, optAuth } from '@/renderer/scripts/composition/authHandler';
import ipc from '@/renderer/scripts/utils/ipc';
import storage from '@/renderer/scripts/utils/storage';
import {
  noPreview,
  isAllowPreviewImage,
  isAllowPrivate,
  isAllowEditDoc,
} from '@/renderer/scripts/composition/allowPreview';
import { authAndLogin } from '@/renderer/scripts/utils/meeting/autoLoginInMeeting';
import tips from '@/renderer/scripts/utils/tips';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { checkVirusStatus } from '@/renderer/scripts/utils/checkVirusStatus';
import smh from '@/renderer/scripts/smh';
import vistor from '@/renderer/scripts/utils/vistor';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { i18n_t } from '@/locales/i18n';
import { IS_BROWSER, IS_PC } from '@/common/constant/platform';

export default defineComponent({
  components: {
    FileIcon,
    MobileList,
    SelectAnySpaceTargetFolder,
    SaveDetail,
    Breadcrumb,
    UserIcon,
    BrowseIcon,
    DownloadIcon,
    EditIcon,
    SaveIcon,
    EllipsisIcon,
    StatusTag,
    UpgradeDialog,
  },
  props: {
    spaceId: {
      type: String,
      default: '',
    },
    spaceOrgId: {
      type: Number,
      default: -1,
    },
    shareLinkDetail: {
      type: Object,
      default: {},
    },
  },
  setup(props, context) {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy || context.root;
    const store = vm.$store;
    // let listBetterScroll: BScroll|null = null;
    // 解构 props
    const { spaceId, spaceOrgId } = toRefs(props);
    let rootPath = storage.get<string[]>(storage.StoreKey.SHARE_LINK_ROOT_PATH) || [];
    const startIndex = ref(0);
    const mobileStyle = computed(() => vm.$store.getters.isMobile || vm.$store.getters.isMobileStyle);
    // 开启预览者水印则需要登录才能下载和预览
    const needLogin = computed(() => {
      const { enableShareWatermark, shareWatermarkType } = props.shareLinkDetail;
      const { isLogined, isVistorLogined } = store.getters;
      return enableShareWatermark && shareWatermarkType === 0 && !isLogined && !isVistorLogined;
    });
    const mobileData = reactive<{
      selectedMap: Record<number, any>;
      list: any[];
    }>({
      selectedMap: [],
      list: [],
    });
    const options = [
      {
        content: i18n_t('举报文件'),
        value: 'offence',
      },
    ];

    const {
      disabledRowKeys,
      loading: loadingList,
      tableData,
      pageData,
      sort,
      methods: listMethods,
    } = listHandler(spaceId);
    const {
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      isFourthButtonHover,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    // 分享外链的column需要增加操作栏
    const columns = computed(() =>
      !mobileStyle.value
        ? [
            {
              colKey: 'row-select',
              type: 'multiple',
              width: 24,
              disabled: ({ row, rowIndex }: { row: any; rowIndex: Number }) => disabledRowKeys.value.includes(rowIndex),
              // className: 'file-page__table-checkbox', // 设置type为multiple后设置className不生效
            },
            {
              colKey: 'name',
              title: 'title-name',
              titleDesc: i18n_t('项目名称'),
              sortType: 'all',
              sorter: true,
              width: 350,
              className: 'col-project-name',
            },
            {
              colKey: 'modificationTime',
              title: 'title-modificationTime',
              titleDesc: i18n_t('修改时间'),
              sortType: 'all',
              sorter: true,
              width: 150,
            },
            {
              colKey: 'size',
              title: 'title-size',
              titleDesc: i18n_t('大小'),
              sortType: 'all',
              sorter: true,
              width: 80,
              fixed: 'right',
            },
            {
              colKey: 'operate',
              title: i18n_t('操作'),
              width: 150,
              fixed: 'right',
            },
          ]
        : [
            {
              colKey: 'row-select',
              type: 'multiple',
              width: 20,
            },
            {
              colKey: 'mobile-name',
              title: i18n_t('项目名称'),
              ellipsis: true,
              width: 180,
            },
            {
              colKey: 'operate',
              title: i18n_t('操作'),
              width: 100,
              align: 'right',
            },
          ],
    );

    const { methods: downloadMethods } = downloadHandler(spaceId);
    const { methods: previewMethods } = openPreviewHandler(spaceId, spaceOrgId);
    const { showSelectTargetFolder, saveDetail, methods: saveToNetDiscMethods } = saveToNetDiscHandler(vm);
    const crumbsRoot = ref<string | string[]>(i18n_t('全部'));
    const crumbs = computed(() => {
      const rootCrumbs = Array.isArray(crumbsRoot.value) ? crumbsRoot.value : [crumbsRoot.value];
      const c = [...rootCrumbs, ...tableData.crumbs];
      return c.map(p => ({
        name: p === crumbsRoot.value ? '' : p,
        content: p,
        type: 'dir',
      }));
    });
    const disableDownloadBtn = computed(
      () => tableData.selectedList.length === 1 && tableData.selectedList.findIndex(item => item.type === 'dir') > -1,
    );

    const showSaveButton = computed(() => {
      const { canSaveToNetDisc, userBaseInfo, isLogined } = store.getters;
      const { isTemporary } = userBaseInfo;
      if (isTemporary && isLogined) return false;
      return canSaveToNetDisc;
    });
    const showSelectAnySpaceTargetFolder = computed(() => {
      const { isLogined } = store.getters;
      return isLogined && showSaveButton.value;
    });

    const showUpgrade = ref(false);

    const methods = {
      async initData() {
        const shareToken = (vm.$route.params?.shareToken as string) || (vm.$route.query?.shareToken as string);
        loadingList.value = true;
        let timer: number | undefined = window.setInterval(async () => {
          const info = await shareAccessTokenManager.get(shareToken);
          // 等shareToken的数据初始化成功之后再拉取数据
          if (info.accessToken) {
            spaceId.value && (await listMethods.pullList());

            // 初始化面包屑导航允许显示索引
            if (rootPath.length === 0) {
              rootPath = tableData.crumbs;
              // 本地缓存初始路径
              storage.set(storage.StoreKey.SHARE_LINK_ROOT_PATH, rootPath);
            } else {
              const include = tableData.crumbs.join().indexOf((rootPath as string[]).join());
              // 若缓存的初始路径与当前初始路径不一致则重新初始化
              if (include !== 0) {
                rootPath = tableData.crumbs;
                // 本地缓存初始路径
                storage.set(storage.StoreKey.SHARE_LINK_ROOT_PATH, rootPath);
              }
            }
            startIndex.value = rootPath.length + 1;
            window.clearInterval(timer);
            timer = undefined;
          }
        }, 1000);
      },
      async onOperateEventProxy(command: string, item?: any, index?: any) {
        const { isLogined, isVistorLogined } = store.getters;
        const loginStr = isLogined ? 'login' : 'nologin';
        switch (command) {
          case 'open':
            if (item.type === 'dir') {
              // 进入文件夹后重置当前页为默认值;
              tableData.crumbs = item.path?.slice(0, -1);
              listMethods.changeCurrentPath(item.name, 'add');
            } else if (noPreview(item)) {
              tips.error(i18n_t('该格式暂不支持在线预览'));
            } else if (!can('Preview', item)) {
              tips.error(i18n_t('暂无在线预览权限，请联系管理员'));
            } else if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              if (needLogin.value) {
                tips.info(i18n_t('分享人设置了访问水印，请登录后继续操作'));
                ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW);
                return;
              }
              // 计算preview页面的数据加载需要从第几页加载，preview默认pageSize为10条
              const { currPage } = pageData;
              // const previewPage = Math.ceil(((currPage - 1) * pageSize + index + 1) / ConstantConfig.previewPageSize);
              storage.set(storage.StoreKey.IMG_PREVIEW_LIST, {
                ...sort,
                ...pageData,
              });
              previewMethods.openPreview(item, currPage);
            }
            break;
          case 'download':
            {
              if (needLogin.value) {
                tips.info(i18n_t('分享人设置了下载水印，请先登录后继续操作'));
                ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW);
                return;
              }
              const tableList = [...tableData.selectedList];
              methods.handleDownload(item ? [item] : tableList);
              reporter.report('link_view', {
                link_view_download: loginStr,
              });
            }
            break;
          case 'refresh':
            {
              const lastPathIndex = crumbs.value.length - 1;
              // 防止当根目录不为空时刷新报无权限
              if (lastPathIndex < startIndex.value) {
                tableData.crumbs = [];
              }
              listMethods.refresh();
              reporter.report('link_view', {
                link_view_refresh: loginStr,
              });
            }
            break;
          case 'preview':
            if (await methods.checkIfUpgraded()) {
              tips.info(i18n_t('账号升级成功，请重新登录'));
              vistor.onLogout();
            } else if (isAllowPreviewImage(item.name) && item.size >= ConstantConfig.ciImageMaxSize) {
              // 万象最大支持32mb
              tips.error(i18n_t('文件过大，请下载至本地查看'));
            } else if (!store.getters.enableDocPreview && !isAllowPrivate(item.name)) {
              if (isAllowEditDoc(item.name)) {
                tips.error(i18n_t('当前文件暂未接入文档预览与编辑服务，请下载至本地查看'));
              } else {
                tips.error(i18n_t('该文件暂不支持预览，请下载至本地查看'));
              }
            } else {
              if (needLogin.value) {
                tips.info(i18n_t('分享人设置了访问水印，请登录后继续操作'));
                ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW);
                return;
              }
              // 计算preview页面的数据加载需要从第几页加载，preview默认pageSize为10条
              const { currPage } = pageData;
              // const previewPage = Math.ceil(((currPage - 1) * pageSize + index + 1) / ConstantConfig.previewPageSize);
              storage.set(storage.StoreKey.IMG_PREVIEW_LIST, {
                ...sort,
                ...pageData,
              });
              previewMethods.openPreview(item, currPage);
              reporter.report('link_view', {
                link_view_preview: loginStr,
              });
            }
            break;
          case 'edit':
            if (store.getters.isVistorLogined) {
              methods.showUpgradeDialog();
              return;
            }
            if (!store.getters.isLogined) {
              tips.info(i18n_t('请先登录后继续操作'));
              if (store.getters.isInWeMeetApp) {
                // 会议里直接授权登录
                setTimeout(() => {
                  authAndLogin((params: any) => {
                    dispatchRouter(params, 'replace');
                  });
                }, 600);
              } else {
                ipc.emit(ipc.RENDERER_EVENTS_MAP.LOGIN_DIALOG_SHOW);
              }
            } else if (!item.authorityList?.canModify) {
              tips.error(i18n_t('暂无权限，请联系管理员'));
            } else {
              await previewMethods.openEdit(item);
              reporter.report('link_view', {
                link_view_edit: loginStr,
              });
            }
            break;
          case 'saveToNetDisc':
            if (store.getters.isVistorLogined) {
              methods.showUpgradeDialog();
              return;
            }
            {
              const tableList = tableData.selectedList.length ? [...tableData.selectedList] : [...tableData.list];
              const itemList = isArray(item) ? item : [item];
              const list = item ? itemList : tableList;
              const params = list.map(o => ({
                userId: Number(o.userId),
                virusAuditStatus: o.virusAuditStatus as number,
                sensitiveWordAuditStatus: o.sensitiveWordAuditStatus as number,
              }));
              let flag = true;
              // 当点击全部保存至网盘的时候出这个提示
              if (!item && tableData.selectedList.length === 0) {
                flag = checkVirusStatus(params, 'allSave');
              } else {
                flag = checkVirusStatus(params, 'save');
              }
              if (flag) {
                saveToNetDiscMethods.handleSaveToNetDisc(list);
                isLogined &&
                  reporter.report('link_view', {
                    link_view_preserve: loginStr,
                  });
              }
            }
            break;
          case 'offence':
            context.emit('offenceShow');
            break;
          default:
            break;
        }
      },
      changeCurrentPath(count?: number) {
        const lastPathIndex = crumbs.value.length - 1;
        if (lastPathIndex > startIndex.value) {
          listMethods.changeCurrentPath(
            crumbs.value[lastPathIndex].name,
            'remove',
            count !== undefined ? count : lastPathIndex - 1,
          );
        } else {
          listMethods.changeCurrentPath('');
        }
      },
      handleDownload(_downloadList: any[], _shareToken?: string) {
        const shareToken =
          _shareToken || (vm.$route.params?.shareToken as string) || (vm.$route.query?.shareToken as string);
        const downloadList: any[] = _downloadList;
        if (!downloadList.length) {
          tips.warning(i18n_t('请选择文件'));
          return;
        }
        // if (!checkVirusStatus(downloadList, 'download')) return;
        downloadMethods.prepareDownload(downloadList, shareToken);
      },
      onMobilePullUp(done: Function) {
        if (pageData.currPage * pageData.pageSize < pageData.total) {
          pageData.currPage++;
          listMethods.pullList().then(() => {
            done();
          });
        }
      },
      onMobileRefresh(done: () => any) {
        pageData.currPage = 1;
        const lastPathIndex = crumbs.value.length - 1;
        // 防止当根目录不为空时刷新报无权限
        if (lastPathIndex < startIndex.value) {
          tableData.crumbs = [];
        }
        listMethods.refresh(done);
      },
      /**
       * 计算表格中更多下拉菜单子项是否渲染
       */
      renderDropdownItemOptions(
        item: any,
        isContextMenu?: boolean,
      ): Array<{
        content: string;
        value: string;
      }> {
        const map: Record<string, string> = {
          preview: i18n_t('预览'),
          edit: i18n_t('编辑'),
          download: i18n_t('下载'),
          saveToNetDisc: i18n_t('保存至网盘'),
        };
        const allow: Record<string, boolean> = {
          preview: optAuth('Preview', item) && item.type !== 'dir',
          edit: optAuth('Edit', item) && item.type !== 'dir',
          download:
            !(store.getters.isInWeMeetApp && store.getters.isMobile) &&
            (IS_PC || (IS_BROWSER && item.type !== 'dir')) &&
            can('Download', item),
          saveToNetDisc: store.getters.canSaveToNetDisc,
        };
        const options: Array<{
          content: string;
          value: string;
        }> = [];
        Object.keys(map).forEach(key => {
          if (allow[key]) {
            options.push({
              content: map[key],
              value: key,
            });
          }
        });
        return options;
      },
      showUpgradeDialog() {
        showUpgrade.value = true;
      },
      async checkIfUpgraded() {
        let flag = false;
        if (store.getters.isVistorLogined) {
          try {
            const res = await smh.userAPI.getUserOrg({
              userToken: Cookies.get('VISTOR_USER_TOKEN'),
            });
            const orgList = res.data;
            if (!orgList || orgList.length === 0) {
              flag = false;
            } else {
              flag = true;
            }
          } catch (error: MsgError) {
            tips.error(error);
          }
        }
        return flag;
      },
    };
    methods.initData();
    return {
      can,
      optAuth,
      showSelectTargetFolder,
      needLogin,
      columns,
      loadingList,
      empty: false,
      ...toRefs(tableData),
      ...toRefs(pageData),
      sort,
      crumbs,
      listMethods,
      startIndex,
      mobileData,
      disableDownloadBtn,
      options,
      mobileStyle,
      saveDetail,
      save: saveToNetDiscMethods.save,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      isThirdButtonHover,
      isFourthButtonHover,
      listOperateMethods,
      ...methods,
      showSaveButton,
      showSelectAnySpaceTargetFolder,
      showUpgrade,
    };
  },
});
